// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const templatesApi = baseApi.injectEndpoints({
  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getAllTemplates: builder.query({
      query: () => {
        return {
          url: "template",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["Template"],
    }),
    getTemplateDetails: builder.query({
      query: (id) => {
        return {
          url: `template/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["Template"],
    }),
    deleteTemplate: builder.mutation({
      query: (id) => {
        return {
          url: `template/${id}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["Template"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllTemplatesQuery,
  useGetTemplateDetailsQuery,
  useDeleteTemplateMutation,
} = templatesApi;
